"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import Api from "../api/api";
import ApiService from "../services/api_service";
import CarrierInvoicesStore from "../stores/carrier_invoices_store";
import CarrierService from "../services/carrier_service";
import DataStoreService from "./data_store_service";
import DocumentIndexerService from "./document_indexer_service";
import DocumentsService from "./documents_service";
import FeaturesService from "./features_service";
import fetch from "../util/fetch";
import LoadDetail from "./indexer/load_detail";
import LoadsService from "./loads_service";
import DocumentBrowserPagination from "../helpers/document_browser_pagination";
import WaitingSpinner from "../components/waiting_spinner";
import DashboardReturnParams from "./ui/dashboard_return_params";
import {
  GroupedDocumentBrowserModel,
  DocumentBatchGroupCreator
} from "./grouped_document_browser_model";
import _ from "underscore";
import hotkeys from "../util/hotkeys";
import Account from "../api/account";
import { fetchDocumentLoadRelationships } from "./helpers/document_load_relationship_fetcher";
import { storeItemChangedEvent } from "../stores/object_with_id_store";
import { push } from "./app_history";
function fetchBulkLines(pages) {
  var withoutLines = _.filter(
    pages,
    (p) => p && p.id && _.isUndefined(p.lines)
  );
  if (withoutLines.length > 0) {
    return ApiService.addErrorHandler(
      fetch(`/api/document_pages/bulk_lines`, {
        data: {
          ids: _.map(withoutLines, (p) => p.id)
        }
      }).then((response) => {
        _.each(response.bulk_lines, (linesObj) => {
          var page = _.find(
            withoutLines,
            (localPage) => localPage.id === linesObj.page_id
          );
          page.lines = linesObj.lines;
        });
        return null;
      }),
      null,
      { caller: "ConfirmAndSubmitPage.fetchBulkLines" }
    );
  }
}
function fetchDocumentBatches(loadState) {
  return DocumentsService.getDocumentBatches(
    loadState.document_batch_ids,
    (db) => false
  );
}
function requiresLtlReconciliation(invoiceID) {
  var invoice = CarrierInvoicesStore.find(invoiceID);
  return invoice && invoice.hasOwnProperty("requires_ltl_reconciliation") && invoice.requires_ltl_reconciliation;
}
function showLoadDocuments(props, loadState) {
  return _.isEmpty(loadState.carrier_invoices) || props.location.query.showLoadDocuments;
}
function currentPage(state, pageToSelect) {
  return pageToSelect || (state.documentModel ? state.documentModel.selectedPage : null);
}
function documentModel(props, state, documentBatches, loadState, invoiceID, pageToSelect) {
  return new GroupedDocumentBrowserModel(
    DocumentBatchGroupCreator(
      documentBatches,
      (doc) => showDocument(props, doc, invoiceID, loadState)
    ),
    function() {
      return false;
    },
    currentPage(state, pageToSelect)
  );
}
function showDocument(props, doc, invoiceID, loadState) {
  if (props.location.query.showLoadDocuments || Account.showAllLoadDocumentsEnabled()) {
    return doc.carrier_invoice_id === invoiceID || !doc.carrier_invoice_id && loadState.document_ids.includes(doc.id);
  } else {
    return doc.carrier_invoice_id === invoiceID || _.isEmpty(loadState.carrier_invoices) && loadState.document_ids.includes(doc.id);
  }
}
function findEmail(props, documentBatches) {
  var emailID = props.location.query["emailMessageId"];
  if (emailID) {
    return _.findWhere(_.pluck(documentBatches, "email_message"), {
      id: parseInt(emailID)
    });
  }
  return _.first(_.compact(_.pluck(documentBatches, "email_message")));
}
function completionContext(props) {
  if (props.location.query["hasMore"] === "true") {
    return "and continue to the next Group";
  } else {
    return "and return to the Dashboard";
  }
}
function wasRedirected(props, invoiceID, loadState) {
  return !showLoadDocuments(props, loadState) && !invoiceID && wasAbleToRedirectToFirstInvoice(props, loadState);
}
function wasAbleToRedirectToFirstInvoice(props, loadState) {
  if (loadState.carrier_invoices.length > 0) {
    var invoiceID = parseInt(loadState.carrier_invoices[0].id);
    if (!isNaN(invoiceID)) {
      var baseUrl = props.location.pathname + "/carrier_invoices/" + invoiceID;
      if (requiresLtlReconciliation(invoiceID)) {
        baseUrl += "/ltl-reconcile";
      }
      push(
        baseUrl,
        _.extend(props.location.query, DashboardReturnParams(props.location))
      );
      return true;
    }
  }
  return false;
}
class ConfirmAndSubmitPage extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "loadDetailRef", React.createRef());
    __publicField(this, "state", {
      loaded: false,
      // unfinished audit re-design, might deprecate
      v3ReskinEnabled: false,
      v3ReskinCheckboxVisible: false,
      documentLoadRelationships: []
    });
    __publicField(this, "mounted", false);
    __publicField(this, "updateDataCallbackId");
    // Bug (DEVEX-963): this.loaded is never set, so `when` is always true. It works by accident:
    // before load the spinner fills the placeholder <div>; after, LoadDetail ignores it as children.
    __publicField(this, "loaded");
    __publicField(this, "addListeners", (props) => {
      $(LoadsService._store).on(
        storeItemChangedEvent("loadState", props.params.loadId),
        this.refresh
      );
      if (props.params.carrierInvoiceId) {
        $(CarrierInvoicesStore).on(
          storeItemChangedEvent("carrierInvoice", props.params.carrierInvoiceId),
          this.refresh
        );
      }
    });
    __publicField(this, "removeListeners", (props) => {
      $(CarrierInvoicesStore).off(
        storeItemChangedEvent("carrierInvoice", props.params.carrierInvoiceId),
        this.refresh
      );
      $(LoadsService._store).off(
        storeItemChangedEvent("loadState", props.params.loadId),
        this.refresh
      );
    });
    __publicField(this, "updateData", (props, pageToSelect) => {
      const currentCallbackId = this.updateDataCallbackId + 1;
      this.updateDataCallbackId = currentCallbackId;
      return Promise.all([
        LoadsService.getLoad(props.params.loadId),
        FeaturesService.ready()
      ]).then((values) => {
        var loadState = values[0];
        return this.setLoadDocumentsAvailable(loadState).then(
          // Bug (DEVEX-963): .then gets a promise, not a function, so the returned promise doesn't wait for the batch fetch. Kept as-is; fix separately.
          fetchDocumentBatches(loadState).then((documentBatches) => {
            documentBatches.forEach(
              (db) => DocumentsService.updateDocuments(db.documents)
            );
            var invoiceID = props.params.carrierInvoiceId;
            if (wasRedirected(this.props, invoiceID, loadState) || currentCallbackId != this.updateDataCallbackId) {
              return;
            }
            invoiceID = parseInt(invoiceID);
            var invoice = CarrierInvoicesStore.find(invoiceID);
            var browserModel = documentModel(
              this.props,
              this.state,
              documentBatches,
              loadState,
              invoiceID,
              pageToSelect
            );
            return CarrierService.carrierWithId(
              invoice ? invoice.carrier_id : loadState.load.carrier_id
            ).then((carrier) => {
              if (this.mounted) {
                this.setState({ carrier });
              }
              return null;
            }).then(() => {
              if (this.mounted) {
                this.setState({
                  loadState,
                  documentModel: browserModel,
                  documentIndexerService: new DocumentIndexerService(
                    {},
                    DataStoreService,
                    Api.Account,
                    this.props.location
                  ),
                  carrierInvoice: invoice,
                  email: findEmail(this.props, documentBatches),
                  loaded: true
                });
                this.updateDocumentLoadRelationships(
                  loadState,
                  documentBatches
                );
              }
              return null;
            }).then(() => {
              if (this.mounted) {
                var docs = this.state.documentModel && this.state.documentModel.activeDocuments();
                if (docs) {
                  var pages = _.flatten(_.map(docs, (d) => d.pages));
                  return fetchBulkLines(pages);
                }
              }
              return null;
            });
          })
        );
      });
    });
    __publicField(this, "refresh", (data) => {
      this.updateData(this.props);
    });
    __publicField(this, "setLoadDocumentsAvailable", (loadState) => {
      return DocumentsService.getDocuments(loadState.document_ids).then(
        (docs) => {
          if (_.some(docs, (d) => {
            return !d.carrier_invoice_id && !d.factor_invoice_id;
          })) {
            this.setState({ loadDocumentsAvailable: true });
          }
          return Promise.resolve(true);
        }
      );
    });
    __publicField(this, "pageReplaced", (args, page) => {
      if (page) {
        const currentPage2 = this.state.documentModel && this.state.documentModel.selectedPage;
        const isUpdatedVersionOfCurrentPage = currentPage2 && currentPage2.document_id === page.document_id && currentPage2.number === page.number;
        if (isUpdatedVersionOfCurrentPage) {
          this.updateData(this.props, page);
        } else {
          this.updateData(this.props);
        }
      }
    });
    __publicField(this, "handleDocumentBatchUpdated", (event, documentBatch) => {
      this.updateData(this.props);
    });
    __publicField(this, "handleDocumentGroupUpdated", (event, documentGroup) => {
      this.updateData(this.props);
    });
    __publicField(this, "updateDocumentLoadRelationships", (loadState, documentBatches) => {
      const documentIds = _.flatten(
        documentBatches.map(
          (batch) => batch.documents.map((doc) => doc.id)
        )
      );
      const loadStateIds = [loadState.id];
      fetchDocumentLoadRelationships(
        documentIds,
        loadStateIds,
        (relationships) => {
          if (this.mounted) {
            this.setState({
              documentLoadRelationships: relationships
            });
          }
        }
      );
    });
    // RENDERING
    __publicField(this, "changePage", (direction) => {
      DocumentBrowserPagination.changePage(this.state.documentModel, direction);
      this.forceUpdate();
    });
    __publicField(this, "toggleDocumentsCallback", () => {
      this.forceUpdate();
    });
    __publicField(this, "content", () => {
      if (this.state.loaded) {
        const loadState = this.state.loadState;
        return (
          // this.state.documentModel must exist because this.state.loaded is only true once it's been set.
          /* @__PURE__ */ jsx(
            LoadDetail,
            {
              ref: this.loadDetailRef,
              toggleDocumentsCallback: this.toggleDocumentsCallback,
              loadDocumentsAvailable: this.state.loadDocumentsAvailable,
              model: this.state.documentModel,
              load: loadState,
              carrierInvoice: this.state.carrierInvoice,
              carrier: this.state.carrier,
              documentIndexerService: this.state.documentIndexerService,
              email: this.state.email,
              completionContext: completionContext(this.props),
              location: this.props.location,
              refresh: this.refresh,
              allowsEditing: true,
              v3ReskinEnabled: this.state.v3ReskinEnabled,
              documentLoadRelationships: this.state.documentLoadRelationships
            },
            loadState.id
          )
        );
      } else {
        return /* @__PURE__ */ jsx("div", {});
      }
    });
    __publicField(this, "v3ReskinCheckbox", () => {
      return /* @__PURE__ */ jsxs(
        "label",
        {
          style: {
            position: "fixed",
            padding: "10px",
            background: "#fffa",
            backdropFilter: "blur(4px)",
            border: "1px solid black",
            borderTopRightRadius: "8px",
            bottom: "-1px",
            left: "-1px",
            display: "flex",
            gap: "8px",
            zIndex: 10
          },
          children: [
            /* @__PURE__ */ jsx(
              "input",
              {
                type: "checkbox",
                style: { margin: 0, outline: 0 },
                onChange: () => {
                  var _a;
                  const newEnabled = !this.state.v3ReskinEnabled;
                  this.setState({ v3ReskinEnabled: newEnabled });
                  (_a = this.loadDetailRef.current) == null ? void 0 : _a.setState({
                    v3ReskinEnabled: newEnabled
                  });
                },
                checked: this.state.v3ReskinEnabled
              }
            ),
            "V3 Reskin Audit"
          ]
        }
      );
    });
  }
  componentDidMount() {
    this.mounted = true;
    this.updateDataCallbackId = 0;
    $(DataStoreService).on(
      "DataStoreService:documentPageReplaced",
      this.pageReplaced
    );
    $(DataStoreService).on(
      "DataStoreService:documentGroupUpdated",
      this.handleDocumentGroupUpdated
    );
    $(DataStoreService).on(
      "DataStoreService:documentBatchUpdated",
      this.handleDocumentBatchUpdated
    );
    hotkeys.listenInComponent(this, AccountsPayable, {
      nextPage: _.partial(this.changePage, "next"),
      prevPage: _.partial(this.changePage, "previous")
    });
    LoadsService._store.enableNotifications();
    CarrierInvoicesStore.enableNotifications();
    this.updateData(this.props).then(() => this.addListeners(this.props));
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      const props = this.props;
      this.removeListeners(prevProps);
      this.updateData(props).then(() => this.addListeners(props));
    }
  }
  componentWillUnmount() {
    this.mounted = false;
    $(DataStoreService).off(
      "DataStoreService:documentPageReplaced",
      this.pageReplaced
    );
    $(DataStoreService).off(
      "DataStoreService:documentGroupUpdated",
      this.handleDocumentGroupUpdated
    );
    $(DataStoreService).off(
      "DataStoreService:documentBatchUpdated",
      this.handleDocumentBatchUpdated
    );
    hotkeys.unlistenInComponent(this);
    this.removeListeners(this.props);
    CarrierInvoicesStore.disableNotifications();
    LoadsService._store.disableNotifications();
  }
  render() {
    const checkbox = this.state.v3ReskinCheckboxVisible ? this.v3ReskinCheckbox() : null;
    return /* @__PURE__ */ jsxs("div", { "data-component": "ConfirmAndSubmitPage", children: [
      /* @__PURE__ */ jsx(WaitingSpinner, { when: !this.loaded, children: this.content() }),
      checkbox
    ] });
  }
}
export default ConfirmAndSubmitPage;
